import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {AQH_FAM_0, AQH_FAM_1, AQH_FAM_2} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {

  constructor(private endpointService: EndpointService) {
  }

  removeFamilyMember(params: AQH_FAM_0) {
    return this.endpointService.aqh_fam_0(params).pipe((map((data => {
      return data;
    }))))
  }

  addFamilyMemberByEmail(params: AQH_FAM_1) {
    return this.endpointService.aqh_fam_1(params).pipe(map((data => {
      return data.data;
    })))
  }

  addChildMember(params: AQH_FAM_2) {
    return this.endpointService.aqh_fam_2(params).pipe(map((data => {
      return data.data;
    })))
  }

}
